import request from './request.js';

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function HSApayment(claimID) {
    const options = {
        endpoint: `/spending/health/payment/${ claimID }`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param hsaMax
 * @param lsaMax
 * @returns {Promise<unknown>}
 */
function setSpendingAccountMaximums(hsaMax, lsaMax) {
    const options = {
        endpoint: '/spending/pooled/maximums',
        method: 'POST',
        body: {
            hsaMax,
            lsaMax
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} filters
 * @param {*} sort
 * @returns
 */
function getHSAClaims(filters, sort) {
    const options = {
        endpoint: `/spending/health/claims`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} filters
 * @param {*} sort
 * @returns
 */
function getLSAClaims(filters, sort) {
    const options = {
        endpoint: `/spending/lifestyle/claims`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function getLsaItems() {
    const options = {
        endpoint: `/spending/lifestyle/items`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    HSApayment,
    setSpendingAccountMaximums,
    getHSAClaims,
    getLSAClaims,
    getLsaItems
};